import React from "react";
import useViewport from "~/assets/js/Helpers/hooks/useViewport";
import i18n from "~/assets/js/Helpers/i18n";

const STATIC_LOGO_URL =
    "/wp-content/plugins/pottsalat/static/images/pottsalat-logo.svg";

const SOCIAL_MEDIA = [
    {
        title: "facebook",
        logo: "/wp-content/plugins/pottsalat/static/images/icons/social-media/facebook.png",
        url: "https://www.facebook.com/pottsalat/",
    },
    {
        title: "instagram",
        logo: "/wp-content/plugins/pottsalat/static/images/icons/social-media/instagram.png",
        url: "https://www.instagram.com/pottsalat/",
    },
    {
        title: "linkedin",
        logo: "/wp-content/plugins/pottsalat/static/images/icons/social-media/linkedin.png",
        url: "https://de.linkedin.com/company/pottsalat",
    },
    {
        title: "pinterest",
        logo: "/wp-content/plugins/pottsalat/static/images/icons/social-media/pinterest.png",
        url: "https://www.pinterest.de/pottsalat/",
    },
    {
        title: "tiktok",
        logo: "/wp-content/plugins/pottsalat/static/images/icons/social-media/tiktok.png",
        url: "https://www.tiktok.com/@pottsalat",
    },
];

const SocialMedia = () => {
    const { isDesktop } = useViewport();

    if (isDesktop) {
        return (
            <div className="footer_social-media">
                <div className="footer_social-media_logo">
                    <img
                        style={{ filter: "brightness(0) invert(1)" }}
                        id="pottsalat-logo"
                        src={
                            reactConfig.logoUrl
                                ? reactConfig.logoUrl
                                : STATIC_LOGO_URL
                        }
                        alt="pottsalat-logo"
                        height={50}
                        width={100}
                    />
                </div>
                <div className="footer_social-media_icons">
                    <p className="footer_social-media_icons_text">
                        {i18n.t("newFooter.socialMediaText")}
                    </p>

                    <div className="footer_social-media_icons_list">
                        {SOCIAL_MEDIA.map((socialMedia) => {
                            return (
                                <a
                                    href={socialMedia.url}
                                    key={`social-media-${socialMedia.title}`}
                                >
                                    <img
                                        key={`social-media-${socialMedia.title}`}
                                        src={socialMedia.logo}
                                        alt="pottsalat-logo"
                                        height={30}
                                        width={30}
                                    />
                                </a>
                            );
                        })}
                    </div>
                </div>
            </div>
        );
    } else {
        return (
            <div className="footer_social-media">
                <div className="footer_inline_container">
                    <div className="footer_social-media_logo">
                        <img
                            style={{ filter: "brightness(0) invert(1)" }}
                            id="pottsalat-logo"
                            src={
                                reactConfig.logoUrl
                                    ? reactConfig.logoUrl
                                    : STATIC_LOGO_URL
                            }
                            alt="pottsalat-logo"
                            height={50}
                            width={100}
                        />
                    </div>
                    <div className="footer_social-media_icons_list">
                        {SOCIAL_MEDIA.map((socialMedia) => {
                            return (
                                <a
                                    href={socialMedia.url}
                                    key={`social-media-${socialMedia.title}`}
                                >
                                    <img
                                        key={`social-media-${socialMedia.title}`}
                                        src={socialMedia.logo}
                                        alt="pottsalat-logo"
                                        height={30}
                                        width={30}
                                    />
                                </a>
                            );
                        })}
                    </div>
                </div>
                <div className="footer_social-media_icons">
                    <p className="footer_social-media_icons_text">
                        {i18n.t("newFooter.socialMediaText")}
                    </p>
                </div>
            </div>
        );
    }
};

export default SocialMedia;
